<template>
    <div class="row productMenuCreateAttributes-block mt-4">
        <div class="col-xl-12 col-xxl-12 p-lr-0-sm">
            <div class="row multisteps-form">
                <div class="col-sm-12 col-md-7 col-lg-7 col-xl-8 col-xxl-7 p-lr-0-sm">
                    <form class="multisteps-form__form dis-flex flex-column">
                        <div class="card bg-gray-200 p-3 dis-flex flex-column mb-4 multisteps-form__content col-sm-12" v-if="attributesList.standardAttribute.attrData.length == 0">
                            <div class="row">
                                <div class="col-12 p-lr-0-sm">
                                    <div class="dis-flex flex-column col-12 p-0">
                                        <div class="dis-flex flex-m flex-sb">
                                            <div class="dis-flex flex-m">
                                                <i class="uis uis-exclamation text-rose fs-20 m-l--8"></i>
                                                <h5 class="text-sm-d">Standard Attribute</h5>
                                            </div>
                                            <small class="text-rose txt-italic">Creating Once</small>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="mr-1 font-p text-rose">Note:</small>
                                            <small class="text-main-dark">Create Componet for standard attribute first!</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-9 p-lr-0-sm">
                                    <div class="dis-flex flex-m flex-sb">
                                        <label>Fill Component</label>
                                        <div class="btn small-form-btn fs-10 pointer" title="Translations Languages">
                                            <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="newAttrData.selected_lang = $event.target.value">
                                                <option v-for="(thisName, thisNameKey) in newAttrData.name" :key="thisNameKey" :value="thisNameKey" :selected="newAttrData.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <template v-for="(thisName, thisNameKey) in newAttrData.name" :key="thisNameKey">
                                        <input v-if="newAttrData.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="It can be Size, Weight, Memory, etc" v-model="newAttrData.name[thisNameKey]">
                                    </template>
                                </div>
                                <div class="col-sm-3 p-lr-0-sm dis-flex flex-column flex-r mt-3">
                                    <button class="btn button-create-atrb-btn mb-0" type="button" title="Create Attribute" :disabled="!componentsAttributesIsAllNamesLength(newAttrData.name, 1)" @click="componentsAttributesAddNewPropToAttr('standardAttribute')">Save</button>
                                </div>
                            </div>
                        </div>

                        <template v-else>
                            <div class="card p-3 dis-flex flex-column mb-4 multisteps-form__content col-sm-12">
                                <div class="row">
                                    <div class="col-sm-12 p-lr-0-sm">
                                        <div class="dis-flex flex-column col-12 p-0">
                                            <div class="dis-flex flex-m">
                                                <i class="uis uis-brightness-plus mr-2 text-rose"></i>
                                                <h5 class="text-sm-b">Create Attribute</h5>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-sm-12 p-lr-0-sm">
                                                <label>Select Attribute Type</label>
                                            </div>
                                            <div class="col-lg-12 p-lr-0-sm">
                                                <div class="dis-flex attr-type-btns">
                                                    <button type="button" class="btn btn-element mr-3" @click="createAttribute.type = 'text'" :class="{'active-btn': createAttribute.type == 'text'}"><i class="uis uis-font mr-2"></i>Text</button>
                                                    <button type="button" class="btn btn-element mr-3" @click="createAttribute.type = 'color'" :class="{'active-btn': createAttribute.type == 'color'}">
                                                        <span class="uim-svg mr-2">
                                                            <svg  enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="1em">
                                                                <path class="uim-quaternary-b" d="M9,22H5c-1.65611-0.00181-2.99819-1.34389-3-3V5c0.00181-1.65611,1.34389-2.99819,3-3h4c1.65611,0.00181,2.99819,1.34389,3,3v14C11.99819,20.65611,10.65611,21.99819,9,22z"></path>
                                                                <path class="uim-tertiary-g" d="M20.29303,6.53516l-2.82819-2.82819c-1.17249-1.16986-3.07068-1.16986-4.24316,0L11.99341,4.9353C11.9939,4.95734,12,4.97784,12,5v14c0,0.02716-0.00732,0.05231-0.00806,0.07928l8.30109-8.30096C21.46289,9.60583,21.46289,7.70764,20.29303,6.53516z"></path>
                                                                <circle cx="7" cy="17" r="1" class="uim-primary"></circle>
                                                                <path class="uim-primary-y" d="M19.06476,12.00659l-7.07281,7.07269C11.99268,19.05231,12,19.02716,12,19c-0.00183,1.65613-1.34387,2.99817-3,3h10c1.65613-0.00183,2.99817-1.34387,3-3v-4C21.99817,13.36603,20.69031,12.04364,19.06476,12.00659z"></path>
                                                            </svg>
                                                        </span>Color
                                                    </button>
                                                    <button type="button" class="btn btn-element mr-3" @click="createAttribute.type = 'photo'" :class="{'active-btn': createAttribute.type == 'photo'}"><i class="uis uis-camera mr-2"></i>Photo</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="attribute-name-component-create mt-3" v-if="createAttribute.type">
                                    <div class="row mt-3">
                                        <div class="col-7 p-lr-0-sm">
                                            <div class="dis-flex flex-m flex-sb">
                                                <label>Attribute Name</label>
                                                <div class="btn small-form-btn fs-10 pointer" title="Translations Languages">
                                                    <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="createAttribute.selected_lang = $event.target.value">
                                                        <option v-for="(thisName, thisNameKey) in createAttribute.name" :key="thisNameKey" :value="thisNameKey" :selected="createAttribute.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <template v-for="(thisName, thisNameKey) in createAttribute.name" :key="thisNameKey">
                                                <input v-if="createAttribute.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="It can be Size, Weight, Memory, etc" v-model="createAttribute.name[thisNameKey]">
                                            </template>
                                        </div>
                                        <div class="col-5 p-lr-0-sm dis-flex flex-column mt-auto p-0">
                                            <div class="col-sm-12 p-lr-0-sm dis-flex">
                                                <button class="btn button-create-atrb-btn mv-ml-2" type="button" title="Create Attribute" :disabled="!componentsAttributesIsAllNamesLength(createAttribute.name, 1)">Create</button>
                                                <button class="btn button-create-atrb-btn close-form ml-auto plr-3" type="button" title="Close Form" @click="createAttribute.type = null"><i class="uis uis-multiply text-white"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card p-3 dis-flex flex-column mb-4" v-if="editAttributeId && attributesList[editAttributeId]">
                                <div class="row">
                                    <div class="col-sm-12 p-lr-0-sm">
                                        <div class="dis-flex flex-m flex-sb">
                                            <div class="dis-flex flex-m">
                                                <i class="uis uis-exclamation text-rose fs-20 m-l--8" v-if="attributesList[editAttributeId].type == 'text' && attributesList[editAttributeId].standardAttribute"></i>
                                                <span class="uim-svg mr-2 active-btn" v-else-if="attributesList[editAttributeId].type == 'color'">
                                                    <svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="1em">
                                                        <path class="uim-quaternary-b" d="M9,22H5c-1.65611-0.00181-2.99819-1.34389-3-3V5c0.00181-1.65611,1.34389-2.99819,3-3h4c1.65611,0.00181,2.99819,1.34389,3,3v14C11.99819,20.65611,10.65611,21.99819,9,22z"></path>
                                                        <path class="uim-tertiary-g" d="M20.29303,6.53516l-2.82819-2.82819c-1.17249-1.16986-3.07068-1.16986-4.24316,0L11.99341,4.9353C11.9939,4.95734,12,4.97784,12,5v14c0,0.02716-0.00732,0.05231-0.00806,0.07928l8.30109-8.30096C21.46289,9.60583,21.46289,7.70764,20.29303,6.53516z"></path>
                                                        <circle cx="7" cy="17" r="1" class="uim-primary"></circle>
                                                        <path class="uim-primary-y" d="M19.06476,12.00659l-7.07281,7.07269C11.99268,19.05231,12,19.02716,12,19c-0.00183,1.65613-1.34387,2.99817-3,3h10c1.65613-0.00183,2.99817-1.34387,3-3v-4C21.99817,13.36603,20.69031,12.04364,19.06476,12.00659z"></path>
                                                    </svg>
                                                </span>
                                                <i class="uis uis-camera mr-2 text-rose" v-else-if="attributesList[editAttributeId].type == 'photo'"></i>
                                                <i class="uis uis-font mr-2 text-rose" v-else-if="attributesList[editAttributeId].type == 'text'"></i>
                                                <h5 class="text-sm-b">{{ componentsGetNormalName(attributesList[editAttributeId].name) }}</h5>
                                            </div>
                                            <div class="dis-flex flex-m">
                                                <i class="uis uis-edit-alt mr-2 text-rose"></i>
                                                <small class="text-rose txt-italic">Editing Attribute</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-sm-12 p-lr-0-sm mb-4">
                                        <label>Attribute Components</label>
                                        <div class="inner-card">
                                            <div class="created-attribute-components flex-m pos-relative" v-for="(thisEditAttrData) in attributesList[editAttributeId].attrData" :key="thisEditAttrData.id">
                                                <i class="uis uis-circle text-rose mr-2" v-if="attributesList[editAttributeId].type == 'color'"></i>
                                                <span class="text-sm-b cl-txt-dark pr-2 bor-right-1" style="cursor: default;">{{ componentsGetNormalName(thisEditAttrData.name) }}</span>
                                                <button class="pos-absolute" title="Remove Attribute" type="button"><i class="uis uis-times fs-18 text-new-light"></i></button>
                                            </div>
                                            <!-- <div class="created-attribute-components flex-m pos-relative">
                                                <i class="uis uis-circle text-success mr-2"></i>
                                                <span class="text-sm-b cl-txt-dark pr-2 bor-right-1">Green</span>
                                                <button class="pos-absolute" type="button" style="right:5px;top:4px;"><i class="uis uis-times fs-18 text-new-light"></i></button>
                                            </div>
                                            <div class="created-attribute-components flex-m pos-relative">
                                                <i class="uis uis-circle text-danger mr-2"></i>
                                                <span class="text-sm-b cl-txt-dark pr-2 bor-right-1">Red</span>
                                                <button class="pos-absolute" type="button" style="right:5px;top:4px;"><i class="uis uis-times fs-18 text-new-light"></i></button>
                                            </div>
                                            <div class="created-attribute-components flex-m pos-relative">
                                                <i class="uis uis-circle mr-2"></i>
                                                <span class="text-sm-b cl-txt-dark pr-2 bor-right-1">Gray</span>
                                                <button class="pos-absolute" type="button" style="right:5px;top:4px;"><i class="uis uis-times fs-18 text-new-light"></i></button>
                                            </div> -->
                                        </div>
                                    </div>

                                    <template v-if="attributesList[editAttributeId].type == 'color'">
                                        <div class="col-8 col-lg-7 p-lr-0-sm mt-3">
                                            <div class="col-sm-12 p-0 dis-flex">
                                                <div class="col-9 col-lg-10 p-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label>Fill Component</label>
                                                        <div class="btn small-form-btn fs-10 pointer" title="Translations Languages">
                                                            <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="newAttrData.selected_lang = $event.target.value">
                                                                <option v-for="(thisName, thisNameKey) in newAttrData.name" :key="thisNameKey" :value="thisNameKey" :selected="newAttrData.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <template v-for="(thisName, thisNameKey) in newAttrData.name" :key="thisNameKey">
                                                        <input v-if="newAttrData.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="It can be Size, Weight, Memory, etc" v-model="newAttrData.name[thisNameKey]">
                                                    </template>
                                                </div>
                                                <div class="col-3 col-lg-2 dis-flex flex-column flex-m pr-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label class="mb-0">Color</label>
                                                    </div>
                                                    <div class="pick-a-color-section mt-auto">
                                                        <label for="pickColor"></label>
                                                        <input type="color" id="pickColor" v-model="newAttrData.color">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4 col-lg-5 dis-flex flex-column mt-auto p-0">
                                            <div class="col-sm-12 p-lr-0-sm dis-flex">
                                                <button class="btn button-create-atrb-btn mv-p-lr-3 mv-ml-2" type="button" title="Add Component to Attribute" :disabled="(!componentsAttributesIsAllNamesLength(newAttrData.name, 1) || !newAttrData.color)" @click="componentsAttributesAddNewPropToAttr(editAttributeId)">Add</button>
                                                <button class="btn button-create-atrb-btn close-form ml-auto plr-3" type="button" title="Close Form" @click="editAttributeId = null"><i class="uis uis-multiply text-white"></i></button>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col-7 p-lr-0-sm">
                                            <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                <label>Fill Component</label>
                                                <div class="btn small-form-btn fs-10 pointer" title="Translations Languages">
                                                    <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="newAttrData.selected_lang = $event.target.value">
                                                        <option v-for="(thisName, thisNameKey) in newAttrData.name" :key="thisNameKey" :value="thisNameKey" :selected="newAttrData.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <template v-for="(thisName, thisNameKey) in newAttrData.name" :key="thisNameKey">
                                                <input v-if="newAttrData.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="It can be Size, Weight, Memory, etc" v-model="newAttrData.name[thisNameKey]">
                                            </template>
                                        </div>
                                        <div class="col-5 dis-flex flex-column mt-auto p-0">
                                            <div class="col-sm-12 p-lr-0-sm dis-flex">
                                                <button class="btn button-create-atrb-btn pl-4 pr-4 mv-ml-2" type="button" title="Add Component to Attribute" :disabled="!componentsAttributesIsAllNamesLength(newAttrData.name, 1)" @click="componentsAttributesAddNewPropToAttr(editAttributeId)">Add</button>
                                                <button class="btn button-create-atrb-btn close-form ml-auto plr-3" type="button" title="Close Form" @click="editAttributeId = null"><i class="uis uis-multiply text-white"></i></button>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </form>
                </div>

                <div class="col-sm-12 col-md-5 col-lg-5 col-xl-4 col-xxl-5 p-lr-0-sm">
                    <form class="multisteps-form__form dis-flex flex-column" v-if="attributesList.standardAttribute.attrData.length > 0">
                        <div class="card multisteps-form__content p-3 dis-flex flex-column mb-4">
                            <div class="dis-flex flex-m flex-sb col-12 p-0 mb-3">
                                <div class="dis-flex flex-m">
                                    <i class="uis uis-brightness-plus mr-2 text-rose"></i>
                                    <h5 class="text-sm-b">Attributes List</h5>
                                </div>
                                <small class="text-rose txt-italic">Ready Attributes</small>
                            </div>
                            <div class="row mb-2">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="bg-white-list">
                                        <div class="dis-flex flex-m flex-sb">
                                            <div class="dis-flex flex-m">
                                                <i class="uis uis-exclamation text-rose fs-20 m-l--8"></i>
                                                <h5 class="text-sm-b">Size</h5>
                                            </div>
                                            <div class="buttons-whatch-attirute">
                                                <div class="btn small-form-btn bar-code fs-10 pointer mr-3 mt-0">
                                                    <i class="uis uis-search fs-11"></i>
                                                </div>
                                                <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" @click="editAttributeId = 'standardAttribute'">
                                                    <i class="uis uis-edit-alt fs-11"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row mb-2">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="bg-white-list">
                                        <div class="dis-flex flex-m flex-sb">
                                            <div class="dis-flex flex-m">
                                                <span class="uim-svg mr-2 active-btn">
                                                    <svg  enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="1em">
                                                        <path class="uim-quaternary-b" d="M9,22H5c-1.65611-0.00181-2.99819-1.34389-3-3V5c0.00181-1.65611,1.34389-2.99819,3-3h4c1.65611,0.00181,2.99819,1.34389,3,3v14C11.99819,20.65611,10.65611,21.99819,9,22z"></path>
                                                        <path class="uim-tertiary-g" d="M20.29303,6.53516l-2.82819-2.82819c-1.17249-1.16986-3.07068-1.16986-4.24316,0L11.99341,4.9353C11.9939,4.95734,12,4.97784,12,5v14c0,0.02716-0.00732,0.05231-0.00806,0.07928l8.30109-8.30096C21.46289,9.60583,21.46289,7.70764,20.29303,6.53516z"></path>
                                                        <circle cx="7" cy="17" r="1" class="uim-primary"></circle>
                                                        <path class="uim-primary-y" d="M19.06476,12.00659l-7.07281,7.07269C11.99268,19.05231,12,19.02716,12,19c-0.00183,1.65613-1.34387,2.99817-3,3h10c1.65613-0.00183,2.99817-1.34387,3-3v-4C21.99817,13.36603,20.69031,12.04364,19.06476,12.00659z"></path>
                                                    </svg>
                                                </span>
                                                <h5 class="text-sm-b">Color</h5>
                                            </div>
                                            <div class="buttons-whatch-attirute">
                                                <div class="btn small-form-btn bar-code fs-10 pointer mr-3 mt-0">
                                                    <i class="uis uis-search fs-11"></i>
                                                </div>
                                                <div class="btn small-form-btn bar-code fs-10 mt-0 pointer">
                                                    <i class="uis uis-edit-alt fs-11"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row mb-2">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="bg-white-list">
                                        <div class="dis-flex flex-m flex-sb">
                                            <div class="dis-flex flex-m">
                                                <i class="uis uis-camera mr-2 text-rose"></i>
                                                <h5 class="text-sm-b">Material</h5>
                                            </div>
                                            <div class="buttons-whatch-attirute">
                                                <div class="btn small-form-btn bar-code fs-10 pointer mr-3 mt-0">
                                                    <i class="uis uis-search fs-11"></i>
                                                </div>
                                                <div class="btn small-form-btn bar-code fs-10 mt-0 pointer">
                                                    <i class="uis uis-edit-alt fs-11"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import componentsGetNormalName from '@/mixins/componentsGetNormalName.js'

let thisComponentData = {
    mixins: [componentsGetNormalName],
    data() {
        return {
            editAttributeId: null,
            attributesList: {
                standardAttribute: {
                    name: {
                        en: 'Standard attribute',
                        ru: 'Стандартный атрибут'
                    },
                    type: 'text',
                    standardAttribute: true,
                    attrData: [
                        {
                            name: {
                                en: '35gr.',
                                ru: '35gr.'
                            },
                            id: 1
                        },
                        {
                            name: {
                                en: '50gr.',
                                ru: '50gr.'
                            },
                            id: 2
                        },
                        {
                            name: {
                                en: '100gr.',
                                ru: '100gr.'
                            },
                            id: 3
                        },
                        {
                            name: {
                                en: '150gr.',
                                ru: '150gr.'
                            },
                            id: 4
                        },
                        {
                            name: {
                                en: '200gr.',
                                ru: '200gr.'
                            },
                            id: 5
                        },
                        {
                            name: {
                                en: '250gr.',
                                ru: '250gr.'
                            },
                            id: 6
                        },
                        {
                            name: {
                                en: '300gr.',
                                ru: '300gr.'
                            },
                            id: 7
                        },
                        {
                            name: {
                                en: '350gr.',
                                ru: '350gr.'
                            },
                            id: 8
                        },
                        {
                            name: {
                                en: '400gr.',
                                ru: '400gr.'
                            },
                            id: 9
                        },
                        // {
                        //     name: {
                        //         en: '37',
                        //         ru: '37'
                        //     },
                        //     id: 10
                        // },
                        // {
                        //     name: {
                        //         en: '38',
                        //         ru: '38'
                        //     },
                        //     id: 11
                        // },
                        // {
                        //     name: {
                        //         en: '39',
                        //         ru: '39'
                        //     },
                        //     id: 12
                        // },
                        // {
                        //     name: {
                        //         en: '40',
                        //         ru: '40'
                        //     },
                        //     id: 13
                        // },
                        // {
                        //     name: {
                        //         en: '41',
                        //         ru: '41'
                        //     },
                        //     id: 14
                        // },
                        // {
                        //     name: {
                        //         en: '42',
                        //         ru: '42'
                        //     },
                        //     id: 15
                        // },
                        // {
                        //     name: {
                        //         en: '43',
                        //         ru: '43'
                        //     },
                        //     id: 16
                        // }
                    ]
                }
            },
            createAttribute: {
                name: {},
                selected_lang: 'en',
                type: null
            },
            newAttrData: {
                name: {},
                selected_lang: 'en',
                color: null,
                photo: null,
            }
        }
    },
    methods: {
        componentsAttributesAddNewPropToAttr: function(thisAttrID) {
            if (this.attributesList.hasOwnProperty(thisAttrID)) {
                let thisAttrInfo = this.attributesList[thisAttrID]
                let thisNewAttrPropData = JSON.parse(JSON.stringify(this.newAttrData))
                delete thisNewAttrPropData.selected_lang
                thisAttrInfo.attrData.push(thisNewAttrPropData)
                flushCreateNewAttr(this)
            }
        },
        componentsAttributesIsAllNamesLength: function(thisNameObj, minLength) {
            let allNameIsWithMinLength = true

            for (const key in thisNameObj) {
                const thisName = thisNameObj[key]
                if (thisName.length < minLength) {
                    allNameIsWithMinLength = false
                    break
                }
            }

            return allNameIsWithMinLength
        }
    },
    watch: {
        '$store.state.languages': {
            handler: function(newLangObj, oldLangObj) {
                for (const key in newLangObj) {
                    if (!this.createAttribute.name.hasOwnProperty(key)) {
                        this.createAttribute.name[key] = ''
                    }
                    if (!this.newAttrData.name.hasOwnProperty(key)) {
                        this.newAttrData.name[key] = ''
                    }
                }
            },
            deep: true
        }
    },
    mounted: function() {
        for (const key in this.$store.state.languages) {
            if (!this.createAttribute.name.hasOwnProperty(key)) {
                this.createAttribute.name[key] = ''
            }
            if (!this.newAttrData.name.hasOwnProperty(key)) {
                this.newAttrData.name[key] = ''
            }
        }
    }
}

function flushCreateNewAttr(thisVue) {
    for (const key in thisVue.newAttrData.name) {
        thisVue.newAttrData.name[key] = ''
    }
    thisVue.newAttrData.color = null
    thisVue.newAttrData.photo = null
}

export default thisComponentData
</script>

<style>

</style>